<template>
  <base-layout :title="title" :backLink="backLink" :reloadable="reloadable">
    <ion-refresher slot="fixed" @ionRefresh="refresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <ion-grid fixed>
      <ion-row>
        <ion-col size="12">
          <list-subject :resources="resources"></list-subject>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-infinite-scroll threshold="100px" @ionInfinite="loadData($event)">
      <ion-infinite-scroll-content
        loading-spinner="bubbles"
        loading-text="Loading more data..."
      >
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
      <ion-fab-button>
        <ion-icon
          :ios="chevronBackCircleOutline"
          :md="chevronBackCircleOutline"
        ></ion-icon>
      </ion-fab-button>
      <ion-fab-list side="start">
        <ion-fab-button @click="setCreateModalState(true)">
          <ion-icon :ios="addOutline" :md="addOutline"></ion-icon>
        </ion-fab-button>
        <ion-fab-button @click="setFilterModalState(true)">
          <ion-icon :ios="funnelOutline" :md="funnelOutline"></ion-icon>
        </ion-fab-button>
      </ion-fab-list>
    </ion-fab>

    <ion-modal
      :is-open="createModalState"
      @didDismiss="setCreateModalState(false)"
    >
      <base-modal
        title="Create Subject"
        @closeModal="setCreateModalState(false)"
      >
        <create-subject
          @closeModal="setCreateModalState(false)"
        ></create-subject>
      </base-modal>
    </ion-modal>

    <ion-modal
      :is-open="filterModalState"
      @didDismiss="setFilterModalState(false)"
    >
      <base-modal
        title="Filter Subject"
        @closeModal="setFilterModalState(false)"
      >
        <filter-subject
          @closeModal="setFilterModalState(false)"
        ></filter-subject>
      </base-modal>
    </ion-modal>
  </base-layout>
</template>

<script>
import BaseLayout from "../../Base/BaseLayout";
import BaseModal from "../../Base/BaseModal";
import FilterSubject from "../../Components/Academic/Subject/FilterSubject.vue";
import ListSubject from "../../Components/Academic/Subject/ListSubject.vue";
import CreateSubject from "../../Components/Academic/Subject/CreateSubject.vue";

import {
  IonGrid,
  IonRow,
  IonCol,
  IonFab,
  IonFabList,
  IonIcon,
  IonFabButton,
  IonModal,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRefresher,
  IonRefresherContent,
} from "@ionic/vue";

import { addOutline, chevronBackCircleOutline, funnelOutline } from "ionicons/icons";

export default {
  components: {
    BaseLayout,
    BaseModal,
    FilterSubject,
    ListSubject,
    CreateSubject,
    IonGrid,
    IonRow,
    IonCol,
    IonFab,
    IonFabList,
    IonIcon,
    IonFabButton,
    IonModal,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonRefresher,
    IonRefresherContent,
  },

  data() {
    return {
      title: "Academic Subjects",
      backLink: "academic",
      reloadable: true,

      createModalState: false,
      filterModalState: false,

      addOutline,
      chevronBackCircleOutline,
      funnelOutline,
    };
  },

  computed: {
    resources() {
      return this.$store.getters["subject/resources"];
    },
    shouldReload() {
      return this.$store.getters["reload"] === this.$route.name;
    },
  },

  watch: {
    shouldReload(current) {
      if (current) {
        this.refresh();
        this.$store.dispatch("clearReload");
      }
    },
  },

  methods: {
    async fetch(refresh = false) {
      await this.$store.dispatch("subject/resources", { refresh: refresh });
    },
    loadData(event) {
      this.fetch();
      event.target.complete();
    },
    async refresh(event) {
      await this.$store.dispatch("subject/resources", { refresh: true });
      if (event) {
        event.target.complete();
      }
    },
    setCreateModalState(state) {
      this.createModalState = state;
    },
    setFilterModalState(state) {
      this.filterModalState = state;
    },
  },

  created() {
    this.fetch();
  },
};
</script>

<style scoped>
</style>
